import React from 'react';
import Button from 'shared/buttons';
import useModal from 'shared/../hooks/useModal';
import MappingRulesModal from './MappingRulesModal';
import {
  SPLIT_ON_TERM, TAKE_FIRST_CHARACTERS, TAKE_LAST_CHARACTERS, REMOVE_TERM,
} from './consts';

const MappingRule = ({ value, onSubmit }) => {
  const { show: showMappingRulesModal } = useModal(MappingRulesModal);

  const onOpenModal = () => showMappingRulesModal({ onSubmit, initialValue: value });

  if (!value) {
    return (
      <div className='mapping-transformation'>
        <Button
          title='Rule'
          icon='plus'
          fillMode='flat'
          themeColor='tertiary'
          onClick={onOpenModal}
        />
      </div>
    );
  }

  const {
    transformationType,
    stringParameter,
    numericParameter,
  } = value;

  const buildText = () => {
    if (transformationType === SPLIT_ON_TERM) {
      return (
        <>
          Split on
          <span className='template-value'>{stringParameter}</span>
          and take part
          <span className='template-value'>{numericParameter + 1}</span>
        </>
      );
    }
    if (transformationType === TAKE_FIRST_CHARACTERS) {
      return (
        <>
          Take first
          <span className='template-value'>{numericParameter}</span>
          characters
        </>
      );
    }
    if (transformationType === TAKE_LAST_CHARACTERS) {
      return (
        <>
          Take last
          <span className='template-value'>{numericParameter}</span>
          characters
        </>
      );
    }
    if (transformationType === REMOVE_TERM) {
      return (
        <>
          Remove
          <span className='template-value'>{stringParameter}</span>
        </>
      );
    }
    return null;
  };

  const ruleText = buildText();

  return (
    <div className='mapping-transformation'>
      <div className='transformation-template'>
        {ruleText}
      </div>
      <Button
        tooltip='Edit'
        icon='edit'
        fillMode='flat'
        themeColor='tertiary'
        onClick={onOpenModal}
      />
    </div>
  );
};

export default MappingRule;
